import { getEnrichmentDisplayInfo } from '@/components/police/utils/policeUtils';
import { Button } from '@/components/ui/button';
import { ReadPoliceDepartment } from '@/services/api/generated/policeReportsService';

import { PoliceStatusBadge } from './PoliceStatusBadge';

interface EnrichmentStatusIndicatorProps {
  /** Police department to show enrichment status for */
  department: ReadPoliceDepartment;
  /** Callback when action button is clicked */
  onActionClick?: (departmentId: string) => void;
}

export const EnrichmentStatusIndicator = ({
  department,
  onActionClick,
}: EnrichmentStatusIndicatorProps) => {
  const config = getEnrichmentDisplayInfo(department.enrichment_status);
  const isLoading = department.enrichment_status === 'enrichment_in_progress';

  const handleActionClick = () => {
    onActionClick?.(department.id);
  };

  return (
    <div className="flex items-center justify-between">
      <PoliceStatusBadge
        enrichmentStatus={department.enrichment_status as any}
        showFullLabel
        showTooltip
      />

      {config.actionable && config.actionText && (
        <Button
          onClick={handleActionClick}
          size="sm"
          variant="outline"
          disabled={isLoading}
        >
          {config.actionText}
        </Button>
      )}
    </div>
  );
};
